import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserDetailComponent} from './detail/user-detail.component';
import {ListViewsModule} from '../shared/list-views/list-views.module';
import {MatTableModule} from '@angular/material/table';
import {PipesModule} from '../shared/pipes/pipes.module';
import {ReactiveFormsModule} from '@angular/forms';
import {MatMenuModule} from '@angular/material/menu';
import {UserDetailInputComponent} from './detail/input/user-detail-input.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {OphButtonModule} from '../shared/design/oph-button/oph-button.module';
import {OphIconModule} from '../shared/design/oph-icon/oph-icon.module';
import {OphAvatarComponent} from '../shared/design/oph-avatar/oph-avatar.component';
import {OphFormFieldModule} from '../shared/design/oph-form-field/oph-form-field.module';

@NgModule({
  declarations: [UserDetailComponent, UserDetailInputComponent],
  imports: [
    CommonModule,
    ListViewsModule,
    MatTableModule,
    PipesModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    OphButtonModule,
    OphIconModule,
    OphAvatarComponent,
    OphFormFieldModule,
  ],
  exports: [UserDetailComponent],
})
export class UsersModule {}
